import React, { useEffect, useState, useRef, useContext  } from "react";
import './subscribe.scss'
import ArrowSVG from "../../components/Arrow";
import { plans } from "./Plan";
import { ConfigProvider, Divider, Modal, Radio, Space } from "antd";
import XSVG from "../../components/X";
import classNames from "classnames";
import XSVG2 from "../../components/X2";
import { useLocation, useNavigate } from "react-router-dom";
import YSVG from "../../components/Y";
import starterbg from '../../assets/starterbg.png'
import advancebg from '../../assets/advancebg.png'
import businessbg from '../../assets/businessbg.png'
import enterprisebg from '../../assets/enterprisebg.png'
import { CHATBOT_BACKEND_URL, MERCHANT_ID, MER_CODE, OPER_ID, SUBMIT_TYPE } from '../../Constants';
import StoredUserContext from "../../context/StoredUserContext";
import { aliWebPay, getOrderCountByClient } from "../../requests/paymentRequest";
import { errorHandler } from "../../requests/errorHandle";

const Detail = (props) => {
    const { plan } = props;
    const getLineThroughCss = (num) => classNames('item-content', 'item-text', {
        'line-through': (num === 0 || num === false) ? true : false,
    })
    return (
        <ul>
            <Space className='plan-content' direction='vertical'>
                <ul className='items-container'>
                    <li>
                        <Space >
                            <span className='item-amt item-text'>{plan.botLimit}</span>
                            <span className='item-content item-text'>Bot limit</span>
                        </Space>
                    </li>
                    <li>
                        <Space>
                            <span className='item-amt item-text'>{plan.validChats}</span>
                            <span className='item-content item-text'>Valid chats/mo</span>
                        </Space>

                    </li>
                    <li>
                        <Space>
                            <span className='item-amt item-text'>{plan.trainingMaterials}</span>
                            <span className='item-content item-text'>Training material</span>
                        </Space>

                    </li>
                    <li>
                        <Space>
                            <span className='item-amt item-text'>{plan.uploadFileSize}</span>
                            <span className='item-content item-text'>Upload file size</span>
                        </Space>
                    </li>
                    <li>
                        <Space>
                            <span className='item-amt item-text'>{plan.chatHistory}</span>
                            <span className='item-content item-text'>Chat history</span>
                        </Space>
                    </li>
                    <div className='hidden-plan-container items-container'>
                        <li>
                            <Space>
                                {
                                    plan.addtionalChats === 0 ? <XSVG /> : <span className='item-amt item-text'>{plan.addtionalChats}</span>
                                }
                                <span className={getLineThroughCss(plan.addtionalChats)}>Additional valid chats</span>
                            </Space>
                        </li>
                        <li>
                            <Space>
                                {
                                    plan.reporting === 0 ? <XSVG /> : <span className='item-amt item-text'>{plan.reporting}</span>
                                }
                                <span className={getLineThroughCss(plan.reporting)}>Reporting</span>
                            </Space>
                        </li>
                        <li>
                            <Space>
                                {
                                    plan.premiumCustomerSupport === 0 ? <XSVG /> : <span className='item-amt item-text'>{plan.premiumCustomerSupport}</span>
                                }
                                <span className={getLineThroughCss(plan.premiumCustomerSupport)}>Premium customer support</span>
                            </Space>
                        </li>
                        <li>
                            <Space>
                                {
                                    plan.leads === 0 ? <XSVG /> : <span className='item-amt item-text'>{plan.leads}</span>
                                }
                                <span className={getLineThroughCss(plan.leads)}>Leads</span>
                            </Space>
                        </li>
                        <li>
                            <Space>
                                {
                                    plan.dataSecurity === false ? <XSVG /> : <YSVG />
                                }
                                <span className={getLineThroughCss(plan.dataSecurity)}>Data security</span>
                            </Space>
                        </li>
                        <li>
                            <Space>
                                {
                                    plan.buttonAction === false ? <XSVG /> : <YSVG />
                                }
                                <span className={getLineThroughCss(plan.buttonAction)}>Button action</span>
                            </Space>
                        </li>
                        <li>
                            <Space>
                                {
                                    plan.chatbotBuildingServices === false ? <XSVG /> : <YSVG />
                                }
                                <span className={getLineThroughCss(plan.chatbotBuildingServices)}>Chatbot building services</span>
                            </Space>
                        </li>
                        <li>
                            <Space>
                                {
                                    plan.chatbotMatenance === false ? <XSVG /> : <YSVG />
                                }
                                <span className={getLineThroughCss(plan.chatbotMatenance)}>Chatbot maintenance</span>
                            </Space>
                        </li>
                        <li>
                            <Space>
                                {
                                    plan.dedicatedAcc === false ? <XSVG /> : <YSVG />
                                }
                                <span className={getLineThroughCss(plan.dedicatedAcc)}>Dedicated acc. manager</span>
                            </Space>
                        </li>
                    </div>
                </ul>
            </Space>
        </ul>
    )
}

const MyRadio = (props) => {
    return (
        <ConfigProvider
            theme={{
                components: {
                    Radio: {
                        colorPrimary: '#F39754',
                        colorBorder: '#845BFB',
                        radioSize: 32,
                        dotSize: 16
                    },
                },
            }}
        >
            <Radio {...props} />
        </ConfigProvider>
    );
}

const imgs = {
    1: starterbg,
    2: advancebg,
    3: businessbg,
    4: enterprisebg,
};

const Subscribe = (props) => {
    const location = useLocation();
    // const {index = 0} = location.state || props.index;
    // debugger;
    const { onClose, index } = props;
    const plan = plans[index];
    const [dur, setDur] = useState(0);
    const [paymentMethod, setPaymentMethod] = useState(0);
    const [subTotal, setSubtotal] = useState(0);
    const [total, setTotal] = useState(0);
    const [GST, setGST] = useState(0);
    const [discount, setDiscount] = useState(0);
    const discountRate = useRef(0.2);
    const [open, setOpen] = useState(false);
    const [contextUser, setContextUser] = useContext(StoredUserContext);

    const navigator = useNavigate();
    useEffect(() => {
        let t;
        let d;
        let g;
        if (dur === 0) {
            t = plan.price.toFixed(2);
            d = (1 - 1).toFixed(2);
            g = (plan.price * 0.13).toFixed(2)
        } else {
            t = (plan.price * 12).toFixed(2);
            d = (plan.price * 12 * discountRate.current).toFixed(2);
            g = ((t - d) * 0.13).toFixed(2)
        }
        setSubtotal(t);
        setDiscount(d);
        setGST(g);
        setTotal(parseFloat(t) - parseFloat(d) + parseFloat(g))
    }, [dur, index])

    const handleClose = () => {
        if (onClose) {
            onClose();
        } else {
            navigator('/home');
        }
    }
    const handleRadioClick = (index) => {
        setDur(index);
    }

    const handlePaymentMethodClick = (index)=>{
        setPaymentMethod(index)
    }
    const monthRadioCss = classNames({
        month: true,
        'cursor-pointer	': true,
        select: dur === 0
    });
    const yearRadioCss = classNames({
        year: true,
        'cursor-pointer	': true,
        select: dur === 1
    });

    const aliRadioCss = classNames({
        month: true,
        'cursor-pointer	': true,
        select: paymentMethod === 0
    });
    const wechatRadioCss = classNames({
        year: true,
        'cursor-pointer	': true,
        select: paymentMethod === 1
    });

    const getPrice = (bool) => {
        if (!bool) {
            return `$${plan.price * (1 - discountRate.current)}/mo`
        } else {
            if (plan.price === -1) {
                return 'Please contact us'
            } else {
                return `$${plan.price}/mo`
            }
        }
    }

    const handleCheckout = async() => {
        // setOpen(true);
        try{
            debugger;
            let {count} = await getOrderCountByClient(contextUser.user_id);
            count++;
            if(count < 10){
                count = '0' + count;
            }
            let orderId = "gptbizid";
            const d = (new Date()).toLocaleDateString();
            const l = d.split('/');
            for(let i = 1; i < 3; i++){
                if(l[i] < 10){
                    l[i] = '0' + l[i];
                }
            }
            const date_string = l.join("");
            orderId += ("_" + date_string + "_" + contextUser.user_id + "_" + (index + 1) + "_" + count);
            
            const params = {
                merCode: MER_CODE,
                merchantId: MERCHANT_ID,
                orderId: orderId,
                operId: OPER_ID,
                amount: total * 100,
                returnURL: btoa(`${CHATBOT_BACKEND_URL}orders/paymentNotify`),
                notifyURL: btoa(`${CHATBOT_BACKEND_URL}orders/paymentNotify`),
                submit_type: SUBMIT_TYPE,
            }
            const res = await aliWebPay(params);
        }catch(err){
            errorHandler(err);
        }
    }

    return (
        <div className="outer-conatiner">
            <div className="inner-container">
                <div className="left" style={index !== 0 ? { backgroundImage: `url(${imgs[index]})` } : {}}>
                    <div className="detail">
                        <h1>{plan.title}</h1>
                        <div ><ArrowSVG /></div>
                        <Detail plan={plan} />
                    </div>
                </div>
                <div className="right">
                    <div className="x" onClick={handleClose}>
                        <XSVG2 />
                    </div>
                    <div className="subcribe">
                        <h2>
                            Subscribe to GPTBIZID
                        </h2>
                        <div style={{ height: '24px' }} />
                        <div className="dur-container">
                            <div className={monthRadioCss} onClick={() => handleRadioClick(0)}>
                                <div className="dur-detail">
                                    <span className="dur">Monthly</span>
                                    <span className="price">{getPrice(dur === 0)}</span>
                                </div>
                                <MyRadio checked={dur === 0} />
                            </div>
                            <div style={{ width: '44px' }} />
                            <div className={yearRadioCss} onClick={() => handleRadioClick(1)}>
                                <div className="dur-detail">
                                    <Space >
                                        <span className="dur">Yearly</span>
                                        <span className="discount">-20%</span>
                                    </Space>
                                    <span className="price">{getPrice(dur === 1)}</span>
                                </div>
                                <MyRadio checked={dur === 1} />
                            </div>
                        </div>
                        <div style={{ height: '58px' }} />
                        <h2>
                            Payment Details
                        </h2>
                        <div style={{ height: '24px' }} />
                        <Space size={'large'}>
                            <MyRadio checked />
                            <h3>OTT Pay</h3>
                        </Space>
                        <div style={{ margin: '29px 0' }} />
                        <div className="dur-container">
                            <div className={aliRadioCss} onClick={() => handlePaymentMethodClick(0)}>
                                <div className="dur-detail">
                                    <span className="dur">Apli pay</span>
                                </div>
                                <MyRadio checked={paymentMethod === 0} />
                            </div>
                            <div style={{ width: '44px' }} />
                            <div className={wechatRadioCss} onClick={() => handlePaymentMethodClick(1)}>
                                <div className="dur-detail">
                                    <span className="dur">Wechat Pay</span>
                                </div>
                                <MyRadio checked={paymentMethod === 1} />
                            </div>
                        </div>
                        <Divider style={{ margin: '58px 0' }} />
                        <Space direction="vertical" style={{ width: '100%' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <span className="text">Subtotal</span>
                                <span className="text">{index === 4 ? 'Please contact us' : `$${subTotal}`}</span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <span className="text" style={{ color: '#F39754' }}>Discount</span>
                                <span className="text" style={{ color: '#F39754' }}>-{index === 4 ? '0.00' : `$${discount}`}</span>
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <span className="text">HST</span>
                                <span className="text">{index === 4 ? 'Please contact us' : `$${GST}`}</span>
                            </div>
                        </Space>
                        <div style={{ height: '24px' }} />
                        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <span className="text">Total</span>
                            <span className="text">{index === 4 ? 'Please contact us' : `$${total}`}</span>
                        </div>
                        <div style={{ height: '58px' }} />
                        <div className="my-button" style={{ width: 'fit-content' }} onClick={handleCheckout}>
                            <span>Subscribe & Checkout</span>
                        </div>
                    </div>
                </div>
            </div>
            <Modal open={open} onCancel={() => setOpen(false)} width={'406px'} footer={null} closeIcon={<XSVG2 />} centered>
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', margin: '24px' }}>
                    <div style={{ height: '24px' }} />
                    <img src={require('../../assets/paymentcode.png')} />
                    <div style={{ marginTop: '24px', width: '358px', display: 'flex', justifyContent: 'center' }}>
                        <div>
                            <span style={{ color: '#845BFB', fontSize: '24px', fontWeight: 500 }}>Scan </span>
                            <span style={{ fontSize: '24px', fontWeight: 500 }}>the QR code to check out</span>
                            <div>
                                <span style={{ fontSize: '12px' }}>Please send us a screenshot of the successful payment page (service@weieducation.ca) after making the payment to help activate your premium plan.</span>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
}


export default Subscribe